import { styled } from '@mui/material/styles';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
import palette from 'theme/palette';

export const SidebarItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => !['active', 'open'].includes(prop as string)
})<{ open: boolean; active?: boolean }>(({ theme, open, active = false }) => ({
  backgroundColor: active ? theme.palette.primary.main : '',
  minHeight: 36,
  alignSelf: 'center',
  justifyContent: open ? 'initial' : 'center',
  borderRadius: '4px',
  margin: theme.spacing(0.5, 0),
  padding: theme.spacing(0.25, 2),

  '& .MuiTouchRipple-root *': {
    backgroundColor: theme.palette.transparent.primary[8]
  },

  '&:hover': {
    backgroundColor: active ? theme.palette.primary.main : palette.secondary.light
  }
}));

export const SidebarItemIcon = styled(ListItemIcon, {
  shouldForwardProp: prop => prop !== 'open'
})<{ open: boolean }>(({ open }) => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 0,
  marginRight: open ? 16 : 'auto'
}));

export const SidebarItemText = styled(ListItemText, {
  shouldForwardProp: prop => prop !== 'open'
})<{ open: boolean }>(({ open }) => ({
  opacity: open ? 1 : 0
}));

export const NavLinkStyled = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  textDecoration: 'none',
  backgroundColor: 'transparent',
  '&:hover': {
    textDecoration: 'none'
  },
  '&:active': {
    color: theme.palette.primary.main
  }
}));
